/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull studio-web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 4
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/ai21/language-studio-dev/implementation/studio-web)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'default';

export const ApiKey: Record<Environment, string> = {
  default: '8a79e0c614753d8f3787c537ecef49d0'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '4',
    branch: 'main',
    source: 'studio-web',
    versionId: '18fb4cc5-5b00-449c-8fbb-4867a1a4efa7'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  ai21_employee?: boolean;
  organization_id?: string;
  organization_plan_type?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | admin, member |
   */
  organization_role?: "admin" | "member";
  origin?: {
    userCreationDate?: number;
  };
}

export interface AgentCreatedProperties {
  /**
   * the created agent's id
   */
  agentId: string;
  /**
   * the agent kind - claude_code, cursor, langchain, other
   */
  agentKind: string;
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface AgentDeletedProperties {
  /**
   * the deleted agent's id
   */
  agentId: string;
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface AgentUpdatedProperties {
  /**
   * the updated agent's id
   */
  agentId: string;
  /**
   * the agent kind - claude_code, cursor, langchain, other
   */
  agentKind: string;
  /**
   * the app firing the event
   */
  app: string;
  /**
   * whether the agent is enabled after the edit (the on/off toggle - cost-relevant)
   */
  enabled: boolean;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface ApiKeyActionPressedProperties {
  /**
   * the action that has pressed
   */
  action: string;
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the host
   */
  host: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface ApiKeyCreatedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface ApiKeyDeletedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface ApiRequestFailedProperties {
  /**
   * the app firing the event - tokenwise
   */
  app: string;
  /**
   * the API endpoint that failed
   */
  endpoint?: string;
  /**
   * error code (the HTTP status code)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  errorCode: number;
  /**
   * the error message shown to the user
   */
  errorMessage: string;
  /**
   * which operation failed (the error discriminator). Loads: boot, loadSummary, loadTrends, loadSessions, loadSessionDetail, loadContext, loadTransformers, loadAgents, loadConfigs, loadApiKeys, loadMembers. Mutations: createAgent, updateAgent, deleteAgent, createConfig, updateConfig, deleteConfig, createApiKey, rotateApiKey, revokeApiKey, renameApiKey, inviteMember, removeMember, createWorkspace, logout
   */
  origin: string;
  /**
   * page where the error occurred
   */
  page?: string;
  /**
   * URL path
   */
  path?: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface AuthStartedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  authMethod?: string;
  authType?: string;
  host?: string;
  origin?: string;
  page?: string;
  path?: string;
  provider?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface ButtonPressedProperties {
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app?:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  buttonText?: string;
  destination?: string;
  entity?: string;
  host?: string;
  itemId?: string;
  origin?: string;
  os_name?: string;
  os_version?: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  source?: string;
  testId?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface ChatErrorProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  errorMessage?: string;
  host?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numStopSequences?: number;
  page?: string;
  path?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface ChatGeneratedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  /**
   * null
   */
  countPenalty?: {
    applyToEmojis?: boolean;
    applyToNumbers?: boolean;
    applyToPunctuations?: boolean;
    applyToStopwords?: boolean;
    applyToWhitespaces?: boolean;
    scale?: number;
  };
  /**
   * documents
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  documents?: string[];
  endpoint?: string;
  epoch?: string;
  /**
   * null
   */
  frequencyPenalty?: {
    applyToEmojis?: boolean;
    applyToNumbers?: boolean;
    applyToPunctuations?: boolean;
    applyToStopwords?: boolean;
    applyToWhitespaces?: boolean;
    scale?: number;
  };
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generatedTextLength: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generatedTextLengthToken?: number;
  interactionId: string;
  isJambaChatEnabled?: any;
  /**
   * max_tokens
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  max_tokens?: number;
  maxTokens?: string;
  messages?: any;
  mock_response?: {
    response_delay_seconds?: {
      [k: string]: any;
    };
    stream_response_delay_between_deltas_seconds?: {
      [k: string]: any;
    };
  };
  model?: string;
  modelId?: string;
  modelType?: string;
  /**
   * n
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  n?: number;
  /**
   * numOfMessages
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfMessages?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numResults?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numStopSequences?: number;
  /**
   * path
   */
  path?: string;
  /**
   * null
   */
  presencePenalty?: {
    applyToEmojis?: boolean;
    applyToNumbers?: boolean;
    applyToPunctuations?: boolean;
    applyToStopwords?: boolean;
    applyToWhitespaces?: boolean;
    scale?: number;
  };
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLengthToken?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptTokenLength?: number;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  requestDuration?: number;
  /**
   * role
   */
  role?: string;
  /**
   * the sessionId
   */
  sessionId?: string;
  setId?: string;
  /**
   * stop
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  stop?: string[];
  stopSequences?: string;
  stream?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  temperature?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  topKReturn?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  topP?: number;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface ChatRequestedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  /**
   * null
   */
  countPenalty?: string;
  /**
   * documents
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  documents?: string[];
  endpoint?: string;
  epoch?: string;
  /**
   * null
   */
  frequencyPenalty?: string;
  hideSelectors?: string;
  host?: string;
  isJambaChatEnabled?: any;
  /**
   * max_tokens
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  max_tokens?: number;
  maxTokens?: string;
  mock_response?: {
    response_delay_seconds?: {
      [k: string]: any;
    };
    stream_response_delay_between_deltas_seconds?: {
      [k: string]: any;
    };
  };
  model?: string;
  modelId?: string;
  /**
   * n
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  n?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfMessages?: number;
  outputId?: string;
  page?: string;
  path?: string;
  /**
   * null
   */
  presencePenalty?: string;
  /**
   * num of characters in prompt
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  role?: string;
  /**
   * the sessionId
   */
  sessionId?: string;
  /**
   * stop
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  stop?: string[];
  stopSequences?: string;
  stream?: any;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  temperature?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  topP?: number;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface ConfigCreatedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the created config profile id
   */
  configId: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface ConfigDeletedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the deleted config profile id
   */
  configId: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface ConfigUpdatedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the updated config profile id
   */
  configId: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface ConversationalRagErrorProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  endpoint?: string;
  errorMessage: string;
  host: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface ConversationalRagGeneratedProperties {
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, studio-api |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp";
  endpoint: string;
  /**
   * file_ids
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  file_ids?: string[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generatedSourcesUsed: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generatedTextLength: number;
  host: string;
  /**
   * hybrid_search_alpha
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hybrid_search_alpha?: number;
  interactionId: string;
  /**
   * max_segments
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  max_segments?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfMessages: number;
  page: string;
  path: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * response_language
   */
  response_language?: string;
  /**
   * retrieval_similarity_threshold
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  retrieval_similarity_threshold?: number;
  /**
   * retrieval_strategy
   */
  retrieval_strategy?: string;
  role: string;
}

export interface ConversationalRagRequestedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  endpoint?: string;
  /**
   * file_ids
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  file_ids?: string[];
  host: string;
  /**
   * hybrid_search_alpha
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  hybrid_search_alpha?: number;
  /**
   * max_segments
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  max_segments?: number;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfMessages?: number;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * response_language
   */
  response_language?: string;
  /**
   * retrieval_similarity_threshold
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  retrieval_similarity_threshold?: number;
  /**
   * retrieval_strategy
   */
  retrieval_strategy?: string;
  role?: string;
}

export interface DocumentUploadFailedProperties {
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp |
   */
  app?:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp";
  documentId?: string;
  documentType?: string;
  /**
   * host
   */
  host?: string;
  /**
   * page
   */
  page?: string;
  path?: string;
  /**
   * reason
   */
  reason?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface DocumentUploadSucceededProperties {
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studio-api, studioWebApp |
   */
  app?:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp";
  documentId?: string;
  documentType?: string;
  /**
   * host
   */
  host?: string;
  /**
   * page
   */
  page?: string;
  path?: string;
  reason?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface FeedbackSubmitErrorProperties {
  answer?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  completionLength: number;
  endpoint?: string;
  errorMessage?: string;
  interactionId?: string;
  model?: string;
  origin: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  questionText?: string;
  reason?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  score?: number;
  type?: string;
}

export interface FeedbackSubmittedProperties {
  answer?: string;
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp |
   */
  app?:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp";
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  completionLength?: number;
  endpoint?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  feedbackScore?: number;
  /**
   * host
   */
  host?: string;
  interactionId?: string;
  model?: string;
  origin?: string;
  /**
   * page
   */
  page?: string;
  path?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  questionText?: string;
  reason?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  requestId?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  score?: number;
  type?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface FilterChangedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * which filter changed - config, routed
   */
  filterType: string;
  /**
   * page where the filter changed
   */
  page?: string;
  /**
   * the new value - selected config id(s) for config; true/false for routed
   */
  value?: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface FormSubmittedProperties {
  accountType?: string;
  alreadyUsingNLP?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, authWebApp, studio-api, studio-identity, studio-docs, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp |
   */
  app:
    | "languageStudioWebapp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "chatApp"
    | "faDemoApp"
    | "studioWebApp";
  companyGoal?: string;
  companyIndustry?: string;
  /**
   * company name or Independent if it is a solo developer
   */
  companyName?: string;
  companySize?: string;
  companyType?: string;
  /**
   * host
   */
  host?: string;
  /**
   * page
   */
  page?: string;
  path?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Hosted (SaaS), Your VPC, On-premise, Not sure yet |
   */
  preferredDeployment?: "Hosted (SaaS)" | "Your VPC" | "On-premise" | "Not sure yet";
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | boolean |
   */
  receiveNewsletter?: boolean[];
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | object |
   */
  referralChannel?: {
    "0"?: string;
    "1"?: string;
    "2"?: string;
    "3"?: string;
    "4"?: string;
    "5"?: string;
    "6"?: string;
    "7"?: string;
    "8"?: string;
    other?: string;
  }[];
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  userRole?: {
    other?: string;
  };
  /**
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  userUseCases?: string[];
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface InviteMemberSentProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | resend, memberInvite |
   */
  method: "resend" | "memberInvite";
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | organizationAccountPage, accountPage |
   */
  origin: "organizationAccountPage" | "accountPage";
}

export interface LogoutButtonPressedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the text that was shown to the user
   */
  buttonText: string;
  /**
   * the host
   */
  host: string;
  /**
   * where the user click on the button
   */
  origin?: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface LogoutSuccessProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp |
   */
  app?: "languageStudioWebapp";
  city?: string;
  country?: string;
  device_brand?: string;
  device_carrier?: string;
  device_family?: string;
  device_id?: string;
  device_manufacturer?: string;
  device_model?: string;
  device_type?: string;
  event_time?: string;
  os_name?: string;
  os_version?: string;
  platform?: string;
  region?: string;
  user_id?: string;
}

export interface MaestroConfigurationUpdatedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the name of the configuration updated
   */
  configurationName: string;
  /**
   * the value of the configuration post update
   */
  configurationValue: string;
  /**
   * the host
   */
  host: string;
  /**
   * page
   */
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface MaestroErrorProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the max budget set by the user for the execution (in USD)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  budget?: number;
  /**
   * the error code
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  errorCode: number;
  /**
   * the error message
   */
  errorMessage: string;
  /**
   * id of the execution
   */
  executionId?: string;
  /**
   * the host
   */
  host?: string;
  /**
   * num of characters in prompt
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength?: number;
  /**
   * the sessionId
   */
  sessionId?: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface MaestroGeneratedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the budget for the execution
   */
  budget?: string;
  /**
   * the actual cost of the execution (in USD)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  executionCost?: number;
  /**
   * id of the execution
   */
  executionId: string;
  /**
   * num of characters in execution result
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  generatedTextLength: number;
  /**
   * the host
   */
  host?: string;
  /**
   * list of models to use, configured by the user
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  models?: string[];
  /**
   * the number of candidate responses generated during the execution
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numCandidates?: number;
  /**
   * num of constraint
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfConstraint: number;
  /**
   * num of context
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfContext: number;
  /**
   * num of files to search in
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfFiles: number;
  /**
   * num of urls to search in
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfUrls: number;
  /**
   * the format of the execution result
   */
  outputFormat?: string;
  /**
   * the page
   */
  page?: string;
  /**
   * the path
   */
  path?: string;
  /**
   * num of characters in prompt
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength: number;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * total execution time of the research request (ms)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  requestDuration?: number;
  /**
   * the sessionId
   */
  sessionId?: string;
  /**
   * list of tools to use, configured by the user
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  tools?: string[];
  /**
   * the score of the top candidate response (0-100)
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  topCandidateScore?: number;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface MaestroQuotaExceededProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the host
   */
  host?: string;
  /**
   * the page
   */
  page?: string;
  /**
   * the path
   */
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * the sessionId
   */
  sessionId?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface MaestroRequestedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the budget for the execution
   */
  budget?: string;
  /**
   * id of the execution
   */
  executionId?: string;
  /**
   * the host
   */
  host?: string;
  /**
   * list of models to use, configured by the user
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  models?: string[];
  /**
   * num of constraint
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfConstraint: number;
  /**
   * num of context
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfContext: number;
  /**
   * num of files to search in
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfFiles: number;
  /**
   * num of urls to search in
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  numOfUrls: number;
  /**
   * the format of the execution result
   */
  outputFormat?: string;
  /**
   * the page
   */
  page?: string;
  /**
   * the path
   */
  path?: string;
  /**
   * num of characters in prompt
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  promptLength: number;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  /**
   * the sessionId
   */
  sessionId?: string;
  /**
   * list of tools to use, configured by the user
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  tools?: string[];
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface PageEnteredProperties {
  _hsenc?: string;
  _hsmi?: string;
  ad_set_name?: string;
  /**
   * the app firing the event
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, jxWebapp, website, studioWebApp, tokenwise |
   */
  app?:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "jxWebapp"
    | "website"
    | "studioWebApp"
    | "tokenwise";
  curr_path?: string;
  curr_search?: string;
  curr_search_fbclid?: string;
  curr_state_from?: {
    key?: string;
    pathname?: string;
    search?: string;
  };
  gad?: string;
  gclid?: string;
  host?: string;
  navAction?: string;
  /**
   * the page
   */
  page?: string;
  pageEnteredNew?: string;
  /**
   * pageHost
   */
  pageHost?: string;
  /**
   * the pagePath
   */
  pagePath?: string;
  path?: string;
  /**
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  prev_durationMillis?: number;
  prev_path?: string;
  prev_search?: string;
  prev_search_fbclid?: string;
  prev_state_from?: {
    key?: string;
    pathname?: string;
    search?: string;
  };
  queryParams?: string;
  referrer?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_medium?: string;
  utm_source?: string;
  utm_term?: string;
  /**
   * the workspaceId
   */
  workspaceId?: string;
}

export interface TimeRangeChangedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * page where the change happened
   */
  page?: string;
  /**
   * the preset before the change
   */
  prevRangePreset?: string;
  /**
   * the selected preset - 5m, 30m, 1h, 6h, 1d, 7d, 30d, custom
   */
  rangePreset: string;
  /**
   * the active workspace ID
   */
  workspaceId: string;
}

export interface UserLoginFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  authMethod?: string;
  authType?: string;
  errorCode?: string;
  errorMessage?: string;
  host?: string;
  origin?: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface UserLoginSucceededProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  authMethod?: string;
  authType?: string;
  host?: string;
  origin?: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface UserSigininSuccessProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp |
   */
  app?: "languageStudioWebapp";
  city?: string;
  country?: string;
  device_brand?: string;
  device_carrier?: string;
  device_family?: string;
  device_id?: string;
  device_manufacturer?: string;
  device_model?: string;
  device_type?: string;
  event_time?: string;
  os_name?: string;
  os_version?: string;
  platform?: string;
  region?: string;
  /**
   * PW/Google
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | GOOGLE, EMAIL_PW |
   */
  signInMethod?: "GOOGLE" | "EMAIL_PW";
  /**
   * SIGNUP/LOGIN
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | LOGIN, SIGNUP |
   */
  signInType?: "LOGIN" | "SIGNUP";
  user_id?: string;
}

export interface UserSignUpFailedProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  authMethod?: string;
  authType?: string;
  errorCode?: string;
  errorMessage?: string;
  host?: string;
  origin?: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface UserSignUpSucceededProperties {
  /**
   * | Rule | Value |
   * |---|---|
   * | Enum Values | languageStudioWebapp, chatApp, faDemoApp, authWebApp, studio-api, studio-identity, studio-docs, studioWebApp, tokenwise |
   */
  app:
    | "languageStudioWebapp"
    | "chatApp"
    | "faDemoApp"
    | "authWebApp"
    | "studio-api"
    | "studio-identity"
    | "studio-docs"
    | "studioWebApp"
    | "tokenwise";
  authMethod?: string;
  authType?: string;
  host?: string;
  origin?: string;
  page?: string;
  path?: string;
  /**
   * referrerPageHost
   */
  referrerPageHost?: string;
  /**
   * referrerPagePath
   */
  referrerPagePath?: string;
}

export interface WorkspaceCreatedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the workspaceId
   */
  workspaceId: string;
}

export interface WorkspaceSwitchedProperties {
  /**
   * the app firing the event
   */
  app: string;
  /**
   * the current workspaceId
   */
  currWorkspaceId: string;
  /**
   * the host
   */
  host: string;
  /**
   * the prev workspaceId
   */
  prevWorkspaceId: string;
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgentCreated implements BaseEvent {
  event_type = 'AgentCreated';

  constructor(
    public event_properties: AgentCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgentDeleted implements BaseEvent {
  event_type = 'AgentDeleted';

  constructor(
    public event_properties: AgentDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AgentUpdated implements BaseEvent {
  event_type = 'AgentUpdated';

  constructor(
    public event_properties: AgentUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApiKeyActionPressed implements BaseEvent {
  event_type = 'APIKeyActionPressed';

  constructor(
    public event_properties: ApiKeyActionPressedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApiKeyCreated implements BaseEvent {
  event_type = 'APIKeyCreated';

  constructor(
    public event_properties: ApiKeyCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApiKeyDeleted implements BaseEvent {
  event_type = 'APIKeyDeleted';

  constructor(
    public event_properties: ApiKeyDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ApiRequestFailed implements BaseEvent {
  event_type = 'ApiRequestFailed';

  constructor(
    public event_properties: ApiRequestFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AuthStarted implements BaseEvent {
  event_type = 'AuthStarted';

  constructor(
    public event_properties: AuthStartedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ButtonPressed implements BaseEvent {
  event_type = 'ButtonPressed';

  constructor(
    public event_properties?: ButtonPressedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatError implements BaseEvent {
  event_type = 'ChatError';

  constructor(
    public event_properties: ChatErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatGenerated implements BaseEvent {
  event_type = 'ChatGenerated';

  constructor(
    public event_properties: ChatGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ChatRequested implements BaseEvent {
  event_type = 'ChatRequested';

  constructor(
    public event_properties: ChatRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConfigCreated implements BaseEvent {
  event_type = 'ConfigCreated';

  constructor(
    public event_properties: ConfigCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConfigDeleted implements BaseEvent {
  event_type = 'ConfigDeleted';

  constructor(
    public event_properties: ConfigDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConfigUpdated implements BaseEvent {
  event_type = 'ConfigUpdated';

  constructor(
    public event_properties: ConfigUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConversationalRagError implements BaseEvent {
  event_type = 'ConversationalRagError';

  constructor(
    public event_properties: ConversationalRagErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConversationalRagGenerated implements BaseEvent {
  event_type = 'ConversationalRagGenerated';

  constructor(
    public event_properties: ConversationalRagGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ConversationalRagRequested implements BaseEvent {
  event_type = 'ConversationalRagRequested';

  constructor(
    public event_properties: ConversationalRagRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentUploadFailed implements BaseEvent {
  event_type = 'DocumentUploadFailed';

  constructor(
    public event_properties?: DocumentUploadFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DocumentUploadSucceeded implements BaseEvent {
  event_type = 'DocumentUploadSucceeded';

  constructor(
    public event_properties?: DocumentUploadSucceededProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackSubmitError implements BaseEvent {
  event_type = 'FeedbackSubmitError';

  constructor(
    public event_properties: FeedbackSubmitErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeedbackSubmitted implements BaseEvent {
  event_type = 'FeedbackSubmitted';

  constructor(
    public event_properties?: FeedbackSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FilterChanged implements BaseEvent {
  event_type = 'FilterChanged';

  constructor(
    public event_properties: FilterChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FormSubmitted implements BaseEvent {
  event_type = 'FormSubmitted';

  constructor(
    public event_properties: FormSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InviteMemberSent implements BaseEvent {
  event_type = 'InviteMemberSent';

  constructor(
    public event_properties: InviteMemberSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LogoutButtonPressed implements BaseEvent {
  event_type = 'LogoutButtonPressed';

  constructor(
    public event_properties: LogoutButtonPressedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LogoutSuccess implements BaseEvent {
  event_type = 'LogoutSuccess';

  constructor(
    public event_properties?: LogoutSuccessProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaestroConfigurationUpdated implements BaseEvent {
  event_type = 'MaestroConfigurationUpdated';

  constructor(
    public event_properties: MaestroConfigurationUpdatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaestroError implements BaseEvent {
  event_type = 'MaestroError';

  constructor(
    public event_properties: MaestroErrorProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaestroGenerated implements BaseEvent {
  event_type = 'MaestroGenerated';

  constructor(
    public event_properties: MaestroGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaestroQuotaExceeded implements BaseEvent {
  event_type = 'MaestroQuotaExceeded';

  constructor(
    public event_properties: MaestroQuotaExceededProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MaestroRequested implements BaseEvent {
  event_type = 'MaestroRequested';

  constructor(
    public event_properties: MaestroRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PageEntered implements BaseEvent {
  event_type = 'PageEntered';

  constructor(
    public event_properties?: PageEnteredProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TimeRangeChanged implements BaseEvent {
  event_type = 'TimeRangeChanged';

  constructor(
    public event_properties: TimeRangeChangedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserLoginFailed implements BaseEvent {
  event_type = 'UserLoginFailed';

  constructor(
    public event_properties: UserLoginFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserLoginSucceeded implements BaseEvent {
  event_type = 'UserLoginSucceeded';

  constructor(
    public event_properties: UserLoginSucceededProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserSigininSuccess implements BaseEvent {
  event_type = 'UserSigininSuccess';

  constructor(
    public event_properties?: UserSigininSuccessProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserSignUpFailed implements BaseEvent {
  event_type = 'UserSignUpFailed';

  constructor(
    public event_properties: UserSignUpFailedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class UserSignUpSucceeded implements BaseEvent {
  event_type = 'UserSignUpSucceeded';

  constructor(
    public event_properties: UserSignUpSucceededProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WorkspaceCreated implements BaseEvent {
  event_type = 'WorkspaceCreated';

  constructor(
    public event_properties: WorkspaceCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class WorkspaceSwitched implements BaseEvent {
  event_type = 'WorkspaceSwitched';

  constructor(
    public event_properties: WorkspaceSwitchedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * AgentCreated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/AgentCreated)
   *
   * Fired when a user creates a new agent
   *
   * @param properties The event's properties (e.g. agentId)
   * @param options Amplitude event options.
   */
  agentCreated(
    properties: AgentCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AgentCreated(properties), options);
  }

  /**
   * AgentDeleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/AgentDeleted)
   *
   * Fired when a user deletes an agent. Also removes the agent's owned config (fires ConfigDeleted), if any
   *
   * @param properties The event's properties (e.g. agentId)
   * @param options Amplitude event options.
   */
  agentDeleted(
    properties: AgentDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AgentDeleted(properties), options);
  }

  /**
   * AgentUpdated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/AgentUpdated)
   *
   * Fired when a user updates an existing agent's settings. Emits agentKind and/or enabled when those change; name and description edits are silent on the wire
   *
   * @param properties The event's properties (e.g. agentId)
   * @param options Amplitude event options.
   */
  agentUpdated(
    properties: AgentUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AgentUpdated(properties), options);
  }

  /**
   * APIKeyActionPressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/APIKeyActionPressed)
   *
   * Fired when a user click on action on api
   *
   * @param properties The event's properties (e.g. action)
   * @param options Amplitude event options.
   */
  apiKeyActionPressed(
    properties: ApiKeyActionPressedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApiKeyActionPressed(properties), options);
  }

  /**
   * APIKeyCreated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/APIKeyCreated)
   *
   * Fired when api key created
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  apiKeyCreated(
    properties: ApiKeyCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApiKeyCreated(properties), options);
  }

  /**
   * APIKeyDeleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/APIKeyDeleted)
   *
   * Fired when api key deleted
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  apiKeyDeleted(
    properties: ApiKeyDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApiKeyDeleted(properties), options);
  }

  /**
   * ApiRequestFailed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ApiRequestFailed)
   *
   * Fired on any API error in the Tokenwise dashboard - data-load failures and failed mutations (agent/config save/delete, API key, invite)
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  apiRequestFailed(
    properties: ApiRequestFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ApiRequestFailed(properties), options);
  }

  /**
   * AuthStarted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/AuthStarted)
   *
   * Fired when Authentication process starting
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  authStarted(
    properties: AuthStartedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AuthStarted(properties), options);
  }

  /**
   * ButtonPressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ButtonPressed)
   *
   * Fired upon any button pressed in the UI - generic event
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  buttonPressed(
    properties?: ButtonPressedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ButtonPressed(properties), options);
  }

  /**
   * ChatError
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ChatError)
   *
   * Fired when a chat request returned an error
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  chatError(
    properties: ChatErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatError(properties), options);
  }

  /**
   * ChatGenerated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ChatGenerated)
   *
   * Fired when a chat result was generated for the user
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  chatGenerated(
    properties: ChatGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatGenerated(properties), options);
  }

  /**
   * ChatRequested
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ChatRequested)
   *
   * Fired when a user activates a chat with an input
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  chatRequested(
    properties: ChatRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ChatRequested(properties), options);
  }

  /**
   * ConfigCreated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConfigCreated)
   *
   * Fired when a config profile is created - via ConfigEditor or seeded by the agent-create flow
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  configCreated(
    properties: ConfigCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConfigCreated(properties), options);
  }

  /**
   * ConfigDeleted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConfigDeleted)
   *
   * Fired when a config profile is deleted - via the ConfigEditor delete row, or the cascade when its owning agent is deleted
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  configDeleted(
    properties: ConfigDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConfigDeleted(properties), options);
  }

  /**
   * ConfigUpdated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConfigUpdated)
   *
   * Fired when a config profile is updated
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  configUpdated(
    properties: ConfigUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConfigUpdated(properties), options);
  }

  /**
   * ConversationalRagError
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConversationalRagError)
   *
   * Fired when the Conversational RAG API returned an error
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  conversationalRagError(
    properties: ConversationalRagErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConversationalRagError(properties), options);
  }

  /**
   * ConversationalRagGenerated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConversationalRagGenerated)
   *
   * Fired when the Conversational RAG API generated a result
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  conversationalRagGenerated(
    properties: ConversationalRagGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConversationalRagGenerated(properties), options);
  }

  /**
   * ConversationalRagRequested
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/ConversationalRagRequested)
   *
   * Fired when the Conversational RAG API was activated
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  conversationalRagRequested(
    properties: ConversationalRagRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ConversationalRagRequested(properties), options);
  }

  /**
   * DocumentUploadFailed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/DocumentUploadFailed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  documentUploadFailed(
    properties?: DocumentUploadFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentUploadFailed(properties), options);
  }

  /**
   * DocumentUploadSucceeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/DocumentUploadSucceeded)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  documentUploadSucceeded(
    properties?: DocumentUploadSucceededProperties,
    options?: EventOptions,
  ) {
    return this.track(new DocumentUploadSucceeded(properties), options);
  }

  /**
   * FeedbackSubmitError
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/FeedbackSubmitError)
   *
   * Fired when an error occured during feedback submission
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. answer)
   * @param options Amplitude event options.
   */
  feedbackSubmitError(
    properties: FeedbackSubmitErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackSubmitError(properties), options);
  }

  /**
   * FeedbackSubmitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/FeedbackSubmitted)
   *
   * Fired when a user submitted a feedback
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. answer)
   * @param options Amplitude event options.
   */
  feedbackSubmitted(
    properties?: FeedbackSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeedbackSubmitted(properties), options);
  }

  /**
   * FilterChanged
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/FilterChanged)
   *
   * Fired when the user changes a non-time dashboard filter - the config filter or the Sessions 'Re-routed only' toggle
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  filterChanged(
    properties: FilterChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FilterChanged(properties), options);
  }

  /**
   * FormSubmitted
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/FormSubmitted)
   *
   * Fired when a user submitted a form
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. accountType)
   * @param options Amplitude event options.
   */
  formSubmitted(
    properties: FormSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FormSubmitted(properties), options);
  }

  /**
   * InviteMemberSent
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/InviteMemberSent)
   *
   * Fired when a new member invite was sent to a user, to join an organization
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  inviteMemberSent(
    properties: InviteMemberSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new InviteMemberSent(properties), options);
  }

  /**
   * LogoutButtonPressed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/LogoutButtonPressed)
   *
   * Fired when a user click on logout
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  logoutButtonPressed(
    properties: LogoutButtonPressedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LogoutButtonPressed(properties), options);
  }

  /**
   * LogoutSuccess
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/LogoutSuccess)
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  logoutSuccess(
    properties?: LogoutSuccessProperties,
    options?: EventOptions,
  ) {
    return this.track(new LogoutSuccess(properties), options);
  }

  /**
   * MaestroConfigurationUpdated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/MaestroConfigurationUpdated)
   *
   * Fired when a user update maestro playground configuration
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  maestroConfigurationUpdated(
    properties: MaestroConfigurationUpdatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaestroConfigurationUpdated(properties), options);
  }

  /**
   * MaestroError
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/MaestroError)
   *
   * Fired when maestro’s execution was failed
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  maestroError(
    properties: MaestroErrorProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaestroError(properties), options);
  }

  /**
   * MaestroGenerated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/MaestroGenerated)
   *
   * Fired when generated text after Maestro execution completed successfully
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  maestroGenerated(
    properties: MaestroGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaestroGenerated(properties), options);
  }

  /**
   * MaestroQuotaExceeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/MaestroQuotaExceeded)
   *
   * Fired when a user hits a quota limit during a Maestro execution attempt
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  maestroQuotaExceeded(
    properties: MaestroQuotaExceededProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaestroQuotaExceeded(properties), options);
  }

  /**
   * MaestroRequested
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/MaestroRequested)
   *
   * Fired when there is a request to Maestro
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  maestroRequested(
    properties: MaestroRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MaestroRequested(properties), options);
  }

  /**
   * PageEntered
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/PageEntered)
   *
   * Fired when the user navigated into a webpage
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. _hsenc)
   * @param options Amplitude event options.
   */
  pageEntered(
    properties?: PageEnteredProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageEntered(properties), options);
  }

  /**
   * TimeRangeChanged
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/TimeRangeChanged)
   *
   * Fired when the user changes the dashboard time range (a preset or a custom range)
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  timeRangeChanged(
    properties: TimeRangeChangedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TimeRangeChanged(properties), options);
  }

  /**
   * UserLoginFailed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/UserLoginFailed)
   *
   * Fired when user login failed
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  userLoginFailed(
    properties: UserLoginFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserLoginFailed(properties), options);
  }

  /**
   * UserLoginSucceeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/UserLoginSucceeded)
   *
   * Fired when user successfully logged in
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  userLoginSucceeded(
    properties: UserLoginSucceededProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserLoginSucceeded(properties), options);
  }

  /**
   * UserSigininSuccess
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/UserSigininSuccess)
   *
   * Owner: data@amplitude.com
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  userSigininSuccess(
    properties?: UserSigininSuccessProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserSigininSuccess(properties), options);
  }

  /**
   * UserSignUpFailed
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/UserSignUpFailed)
   *
   * Fired when user signup failed
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  userSignUpFailed(
    properties: UserSignUpFailedProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserSignUpFailed(properties), options);
  }

  /**
   * UserSignUpSucceeded
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/UserSignUpSucceeded)
   *
   * Fired when user successfully signed up
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  userSignUpSucceeded(
    properties: UserSignUpSucceededProperties,
    options?: EventOptions,
  ) {
    return this.track(new UserSignUpSucceeded(properties), options);
  }

  /**
   * WorkspaceCreated
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/WorkspaceCreated)
   *
   * Fired when a new workspace has been created
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  workspaceCreated(
    properties: WorkspaceCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WorkspaceCreated(properties), options);
  }

  /**
   * WorkspaceSwitched
   *
   * [View in Tracking Plan](https://data.amplitude.com/ai21/language-studio-dev/events/main/latest/WorkspaceSwitched)
   *
   * Fired when a user switch the workspace
   *
   * @param properties The event's properties (e.g. app)
   * @param options Amplitude event options.
   */
  workspaceSwitched(
    properties: WorkspaceSwitchedProperties,
    options?: EventOptions,
  ) {
    return this.track(new WorkspaceSwitched(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
